<template>
  <section class="space-y-5">
    <h3 v-if="!hideTitle" class="text-text-neutral-primary text-lg font-bold">
      {{ routeTitle }}
    </h3>

    <div v-if="group.savedSearches.length > 0" class="space-y-3">
      <div class="flex items-center gap-1">
        <SearchIcon class="text-text-info-primary size-4 shrink-0" />
        <p class="text-text-neutral-primary text-xs">
          <span>{{ t('favoritesPage.savedSearchesHeading') }}</span>
          <span> • </span>
          <span>{{ group.savedSearches.length }}</span>
        </p>
      </div>
      <div class="space-y-3">
        <FavoritesSavedSearchCard
          v-for="item in group.savedSearches"
          :key="item.id"
          :item="item"
          @remove="$emit('remove', $event)"
          @open="$emit('openItem', $event)"
        />
      </div>
    </div>

    <div v-if="group.savedTickets.length > 0" class="space-y-3">
      <div class="flex items-center gap-2">
        <FavoriteActiveIcon
          class="text-text-negative-primary size-4 shrink-0"
        />
        <p class="text-text-neutral-primary text-xs">
          <span>{{ t('favoritesPage.savedTicketsHeading') }}</span>
          <span> • </span>
          <span>{{ group.savedTickets.length }}</span>
        </p>
      </div>
      <div class="space-y-3">
        <FavoritesTicketCard
          v-for="item in group.savedTickets"
          :key="item.id"
          :item="item"
          :dict="dict"
          @remove="$emit('remove', $event)"
          @open="$emit('openItem', $event)"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';

  import {
    routeTitleFromEndpoints,
    routeTitleFromRouteString,
    type FavoriteGroup,
    type WatchlistItem,
  } from '@/features/favorites';

  import FavoriteActiveIcon from '@/assets/images/favorite-active-icon.svg?component';
  import SearchIcon from '@/assets/images/search-icon.svg?component';

  import FavoritesSavedSearchCard from './FavoritesSavedSearchCard.vue';
  import FavoritesTicketCard from './FavoritesTicketCard.vue';

  const props = defineProps<{
    group: FavoriteGroup;
    dict?: Dict.Entity;
    hideTitle?: boolean;
  }>();

  defineEmits<{
    remove: [item: WatchlistItem];
    openItem: [item: WatchlistItem];
  }>();

  const { locale, t } = useI18n();

  const routeTitle = computed(() => {
    const lang = locale.value as 'ru' | 'kk' | 'en';
    const route = props.group.items[0]?.route;
    const fromRoute = routeTitleFromRouteString(route, props.dict, lang);
    if (fromRoute) return fromRoute;
    return routeTitleFromEndpoints(
      props.group.direction.dep,
      props.group.direction.arr,
      props.dict,
      lang,
    );
  });
</script>
